module.exports = __webpack_public_path__ + "static/img/bb1.485fd51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bb1.png
// module id = RRck
// module chunks = 2